import AddressesTableItemLoading from './AddressesTableItemLoading'

export default AddressesTableItemLoading
